export default [
    {
        path:'wall/:coursewareId/:groupId/:discussId',
        component(resolve) {
            require(['@/components/student/discuss/wall'], resolve)
        },
        meta: {  
            title : '讨论墙'
        }
    },
    {
        path:'free/:coursewareId/:discussId',
        component(resolve) {
            require(['@/components/student/discuss/free'], resolve)
        },
        meta: {  
            title : '自由讨论'
        }
    },
    {
        path:'history/index/:coursewareId/:discussId/:groupId',
        component(resolve) {
            require(['@/components/student/discuss-history/index'], resolve)
        },
        meta: {  
            title : '讨论墙'
        }
    },
    {
        path:'history/list/:coursewareId',
        component(resolve) {
            require(['@/components/student/discuss-history/list'], resolve)
        },
        meta: {  
            title : '讨论墙'
        }
    },
    {
        path:'history/group/:coursewareId/:discussId/:groupId',
        component(resolve) {
            require(['@/components/student/discuss-history/group'], resolve)
        },
        meta: {  
            title : '讨论墙'
        }
    }
]


// WEBPACK FOOTER //
// ./src/router/student/discuss.js